import React from 'react';
import { Icon } from './Icon.js';
export const IconFlask = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M5 16L5.80474 16.503C7.80916 17.7557 10.2963 17.9599 12.4782 17.0508C14.1043 16.3732 15.9206 16.3069 17.5918 16.8639L19.5 17.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8 2H10V11C6.3228 12.8386 4 16.597 4 20.7082V22H20V20.7082C20 16.597 17.6772 12.8386 14 11V2H16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconFlask.js.map